// Toggle the menu open and close when on mobile
export default function menuOpen() {
    let menuOpen = false;
    const burgerButton = document.querySelector('.gh-burger');
    if (!burgerButton) { return; }
    burgerButton.addEventListener('click', function () {
        document.body.classList.toggle('gh-head-open');
        menuOpen = !menuOpen;
    });

    document.addEventListener('click', function (e) {
        if (e.target.closest('#gh-nav')) {
            return;
        }
        if (menuOpen) {
            document.body.classList.remove('gh-head-open');
            menuOpen = false;
        }
    });
}